import { makeObservable, observable } from 'mobx';

import { TagModel } from 'shared/models';
import { ModelArrayCast } from 'shared/casts';

import { Model } from './Model';

export interface IEntryPassModel {
    id: number;
    entryAt: string;
    transport: string;
    visitor: string;
    phone: string;
    comment: string;
}

export class EntryPassModel extends Model implements IEntryPassModel {
    casts = {
        tags: new ModelArrayCast(TagModel),
    };

    id = 0;
    entryAt = '';
    transport = '';
    phone = '';
    visitor = '';
    comment = '';

    constructor(payload: Partial<IEntryPassModel> = {}) {
        super();

        makeObservable(this, {
            id: observable,
            entryAt: observable,
            transport: observable,
            visitor: observable,
            phone: observable,
            comment: observable,
        });

        this.update(payload);
    }
}
